import Head from "components/Head"
import Link from "next/link"

import JobHeader from "components/jobs/JobHeader"
import { CalendarIcon, MapPinIcon } from "@heroicons/react/24/solid"

import positions from "components/jobs/positions.json"
import Breadcrumbs from "components/jobs/Breadcrumbs"

const pages = [{ name: "Careers", href: "/careers", current: true }]

export default function IndexPage() {
  return (
    <div className="h-full">
      <Head share_img="https://paragraph.xyz/featureline/success.png" />

      <main className="h-full">
        <JobHeader />
        <div className="bg-gray-50 h-full py-12 px-4">
          <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <Breadcrumbs pages={pages} />

            <h3 className="text-2xl leading-6 font-medium text-gray-900 my-6">
              Open Roles
            </h3>

            <div className="bg-white shadow overflow-hidden sm:rounded-md">
              <ul role="list" className="divide-y divide-gray-200">
                {positions
                  .filter((p) => !p.closed)
                  .map((position) => (
                    <li key={position.id}>
                      <Link
                        href={"/careers/" + position.url}
                        className="block hover:bg-gray-50"
                      >
                        <div className="px-4 py-4 sm:px-6">
                          <div className="flex items-center justify-between">
                            <p className="text-sm font-medium text-blue-600 truncate">
                              {position.title}
                            </p>
                            <div className="ml-2 flex-shrink-0 flex">
                              <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                {position.type}
                              </p>
                            </div>
                          </div>
                          <div className="mt-2 sm:flex sm:justify-between">
                            <div className="sm:flex">
                              {/*
                            <p className="flex items-center text-sm text-gray-500">
                              <CurrencyDollarIcon
                                className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                              {position.salary} USD
                              </p> */}
                              <p className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                                <MapPinIcon
                                  className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                  aria-hidden="true"
                                />
                                {position.location}
                              </p>
                            </div>
                            <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                              <CalendarIcon
                                className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                            </div>
                          </div>
                        </div>
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </main>

      <main className="max-w-3xl"></main>
    </div>
  )
}
